var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("Estudiantes Activos")]),_c('div',{staticClass:"chart-container"},[_c('DashboardEstudiantesActivosChart',{ref:"chart",attrs:{"chartdata":_vm.data,"options":_vm.options,"width":500,"height":200}})],1),_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":_vm.actualizar}},[_vm._v("Actualizar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }